import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "../../constants";
import { isLoggedIn } from "../authContext";

export const PrivateRoute = () => {
  return isLoggedIn() ? <Outlet /> : <Navigate to={ROUTES.HOME} />;
};
